// extracted by css-extract-rspack-plugin
export default {"container":"container-GXglqr","input":"input-Mraw77"};